// state
const state = () => ({
    user: [],
    user_id: [],
  });
  
  // getters
  const getters = {};
  
  // actions
  const actions = {
    getUser({ commit }, fields) {
      commit('getUser', fields);
    },
  };
  
  // mutations
  const mutations = {
    getUser(state, data) {
      state.user = data;
      state.user_id = data.id;
    },
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };


// WEBPACK FOOTER //
// ./src/store/modules/user.js